import HeaderVerde from '../HeaderVerde'
import Input from '../Input'
import Select from '../Select'
import Observacoes from '../Observacoes'
import Caixa from '../Caixa'
import CheckContainer from '../CheckContainer'
import CheckBox from '../CheckBox'
import Cidade from '../Modulos/Cidades.js'
import React from 'react'

import { useSelector } from 'react-redux'

const TOpublicidadeRedeSocial = (props) => {
    const modulo = props.modulo
    const updatedForm = useSelector((state) => state.addForm.qtdModulos[modulo])
    const condicional = useSelector((state) => state.addForm.modulos)
    const ficha = useSelector((state) => state.addForm.ficha)

    return (
        <>
            {RenderModulo()}
        </>
    )

    function RenderModulo() {
        let partes = []
        if(ficha[modulo]) var qtdFicha = ficha[modulo].length
        let quantidade = updatedForm || qtdFicha
        for (let n = 0; n < quantidade; n++) {
            partes.push(
                <Caixa>
                    <HeaderVerde texto="PERFIL SOCIAL" />
                    <div style={{ textAlign: "left" }}>

                        <Input label="Perfil Social" nome="perfil" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="49vw" widthMobile="80vw" marginR="3vw" />
                        <Select label="Rede Social" nome="rede" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="14vw" widthMobile="80vw" marginR="3vw"
                            array={["Instagram", "Facebook", "Facebook e Instagram"]} />
                        <Select label="Tipo de Perfil" nome="tipoperfil" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="14vw" widthMobile="80vw" marginR="3vw"
                            array={["Privado", "Público"]} />
                    </div>

                    <HeaderVerde texto="IDENTIFICAÇÃO DO PROFISSIONAL" />
                    <div style={{ textAlign: "left" }}>
                        <Select label="Profissional Identificado" nome="profissional" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="11vw" widthMobile="80vw" marginR="2vw"
                            array={["Sim", "Não"]} />
                        {RenderCondicional1()}
                    </div>

                    <HeaderVerde texto="MOTIVO DA VERIFICAÇÃO" />
                    <div style={{ textAlign: "left" }}>
                        <Select label="Denúncia" nome="denuncia" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="7vw" widthMobile="80vw" marginR="2vw"
                            array={["Sim", "Não"]} />
                        {RenderCondicional2()}
                    </div>

                </Caixa>
            )

            function RenderCondicional1() {
                let campos = []
                if (condicional[modulo].length > 0) var array = condicional
                else var array = ficha
                var quantidade = array[modulo][n]["profissional"]
                if (array[modulo][n]["profissional"] === "Sim") {
                    campos.push(
                        <>
                            <Select label="Situação" nome="situacao" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="11vw" widthMobile="80vw" marginR="3vw"
                                array={["Ativo", "Baixado"]} />
                            <Input label="Nome" nome="nome" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="56vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="Crefito nº" nome="crefitonumero" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="Endereço" nome="endereco" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="49vw" widthMobile="80vw" marginR="3vw" />
                            <Select label="UF" nome="uf" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="15vw" widthMobile="80vw" marginR="3vw"
                                array={["AL", "PB", "PE", "RN"]} />
                            <Select label="Município" nome="municipio" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="15vw" widthMobile="80vw" marginR="3vw"
                                array={Municipio(array[modulo][n].uf)} />
                            <Observacoes widthWeb="83vw" widthMobile="80vw" modulo={modulo} index={n} nome="observacoes" />
                        </>
                    )
                }
                if (array[modulo][n]["profissional"] === "Não") {
                    campos.push(
                        <>
                            <Select label="Mais de um Possível Profissional no Incorp" nome="incorpredesocial" modulo={modulo} index={n}
                                widthWeb="20vw" widthMobile="80vw" marginR="3vw"
                                array={["Sim", "Não"]} />
                            <Select label="Suspeita de Exercício Ilegal" nome="ilegalredesocial" modulo={modulo} index={n}
                                widthWeb="20vw" widthMobile="80vw" marginR="3vw"
                                array={["Sim", "Não"]} />
                            <Select label="Possível" nome="ilegalredesocial" modulo={modulo} index={n}
                                widthWeb="20vw" widthMobile="80vw" marginR="3vw"
                                array={["Estudante", "Leigo", "Não se Aplica"]} />
                        </>
                    )
                }

                function Municipio(uf) {
                    let municipios = []
                    if(uf) Cidade[uf].map(el => municipios.push(el.nome))
                    return municipios
                }

                return campos
            }
            function RenderCondicional2() {
                let campos = []
                if (condicional[modulo].length > 0) var array = condicional
                else var array = ficha
                var quantidade = array[modulo][n]["denuncia"]
                if (array[modulo][n]["denuncia"] === "Sim") {
                    campos.push(
                        <>
                            <Input label="Protocolo nº" nome="protocolo" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Select label="Verificação" nome="verificacao" modulo={modulo} index={n}
                                componentDisplay="block" widthWeb="16vw" widthMobile="80vw" marginR="3vw"
                                array={["De Adequação", "De Rotina", "Por Denúncia"]} />
                            <Select label="Foi Anexada Mídia(s) a Denúncia" nome="midea" modulo={modulo} index={n}
                                componentDisplay="block" widthWeb="16vw" widthMobile="80vw" marginR="3vw"
                                array={["Sim", "Não"]} />
                            <Select label=" O Conteúdo Denunciado Continua sendo Divulgado na Rede Social" nome="denunciado" modulo={modulo} index={n}
                                componentDisplay="block" widthWeb="16vw" widthMobile="80vw" marginR="3vw"
                                array={["Sim", "Não"]} />
                            <Select label="Trata-se de Publicação que Expira com Tempo Determinado" nome="publiredesocial" modulo={modulo} index={n}
                                componentDisplay="block" widthWeb="16vw" widthMobile="80vw" marginR="3vw"
                                array={["Sim", "Não", "Parcialmente"]} />
                            <Observacoes widthWeb="83vw" widthMobile="80vw" modulo={modulo} index={n} nome="observacoes2" />
                        </>
                    )
                }
                if (condicional[modulo].length > 0) var array = condicional
                else var array = ficha
                var quantidade = array[modulo][n]["denuncia"]
                if (array[modulo][n]["denuncia"] === "Não") {
                    campos.push(
                        <>
                            <Select label="Verificação" nome="verificacaonao" modulo={modulo} index={n}
                                componentDisplay="block" widthWeb="12vw" widthMobile="80vw" marginR="3vw"
                                array={["De Adequação", "De Rotina"]} />
                            <Select label="O Conteúdo Continua sendo Divulgado na Rede Social" nome="denunciadonao" modulo={modulo} index={n}
                                componentDisplay="block" widthWeb="12vw" widthMobile="80vw" marginR="3vw"
                                array={["Sim", "Não"]} />
                            <Select label="Trata-se de Publicação que Expira com Tempo Determinado" nome="publiredesocialnao" modulo={modulo} index={n}
                                componentDisplay="block" widthWeb="12vw" widthMobile="80vw" marginR="3vw"
                                array={["Sim", "Não", "Parcialmente"]} />
                            <Observacoes widthWeb="83vw" widthMobile="80vw" modulo={modulo} index={n} nome="observacoes" />
                        </>
                    )
                }
                return campos
            }
        }
        return partes
    }
}
export default TOpublicidadeRedeSocial